define( 'breakpoint',[ 'jquery' ],
function( $ ) {

	'use strict';

	var breakpoint = {};

	breakpoint.init = function() {

		this.set();
		$( window ).on( 'resize orientationchange', $.proxy( this.set, this ) );
	};

	breakpoint.set = function() {

		var html_node          = document.getElementsByTagName( 'html' )[0],
		breakpoint_class_name  = html_node.className.match( /breakpoint-([a-z]+)/ ),
		current_breakpoint     = breakpoint_class_name === null ? null : breakpoint_class_name[1],
		pv                     = window.getComputedStyle ? window.getComputedStyle( html_node, ':after' ).getPropertyValue( 'content' ) : undefined,
		bp                     = pv ? pv.replace( /"/g, '' ) : undefined,
		ob                     = current_breakpoint;

		if ( bp && bp !== current_breakpoint ) {

			html_node.className =  html_node.className.replace(/\s?breakpoint-[a-z]+/,'');
			html_node.className += ' breakpoint-' + bp;

			current_breakpoint = bp;

			$( breakpoint ).trigger( 'change', [bp, ob]);
		}
	};

	return breakpoint;
} );
